import { render, staticRenderFns } from "./Myspeed.vue?vue&type=template&id=34662d28&scoped=true"
import script from "./Myspeed.vue?vue&type=script&lang=js"
export * from "./Myspeed.vue?vue&type=script&lang=js"
import style0 from "./Myspeed.vue?vue&type=style&index=0&id=34662d28&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34662d28",
  null
  
)

export default component.exports